import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '@/components/HomeView.vue'
import ListView from '@/components/ListView.vue'
import DetailsView from '@/components/DetailsView.vue'
import HistoryView from '@/components/HistoryView.vue'
import RevisionsView from '@/components/RevisionsView.vue'
import RevisionsDetailView from '@/components/RevisionsDetailView.vue'
import MilkView from '@/components/MilkView.vue'
import BackupsView from '@/components/BackupsView.vue'
import SyncsView from '@/components/SyncsView.vue';
import StatisticsView from '@/components/StatisticsView.vue'
import LoginView from '@/components/LoginView.vue';
import RegistrateView from '@/components/RegistrateView.vue';
import ResetPasswordView from '@/components/ResetPasswordView.vue';
import LandingPageView from '@/components/LandingPageView.vue';
import AuthService from '@/services/auth-service';
import SnackbarSercie from '@/services/snackbar-service'
import VerifyRegistraionView from '@/components/VerifyRegistraionView.vue';
import SettingsView from '@/components/settings/SettingsView.vue';
import UploadView from '@/components/upload-data/UploadView.vue';
import ContactView from '@/components/ContactView.vue';
import LicenceView from '@/components/LicenceView.vue';
import PrivacyView from '@/components/PrivacyView.vue';
import TermsAndConditionsView from '@/components/TermsAndConditionsView.vue';
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'landingPage',
    component: LandingPageView,
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
  },
  {
    path: '/registrate',
    name: 'registrate',
    component: RegistrateView,
  },
  {
    path: '/verify-registration/:token',
    name: 'verifyRegistration',
    component: VerifyRegistraionView
  },
  {
    path: '/reset-password/:token',
    name: 'resetPassword',
    component: ResetPasswordView
  },
  {
    path: '/contact',
    name: 'contact',
    component: ContactView
  },
  {
    path: '/licence',
    name: 'licence',
    component: LicenceView
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: PrivacyView
  },
  {
    path: '/terms-and-conditions',
    name: 'termsAndConditions',
    component: TermsAndConditionsView
  },
  {
    path: '/cows',
    name: 'cows',
    component: ListView,
  },
  {
    path: '/cows-dead',
    name: 'cows-dead',
    component: ListView,
  },
  {
    path: '/cows-sold',
    name: 'cows-sold',
    component: ListView,
  },
  {
    path: '/cows/:id',
    name: 'cow-details',
    component: DetailsView,
  },
  {
    path: '/history',
    name: 'history',
    component: HistoryView,
  },
  {
    path: '/revisions',
    name: 'revisions',
    component: RevisionsView,
  },
  {
    path: '/revisions/:farmId/:date',
    name: 'revisions-detail',
    component: RevisionsDetailView,
  },
  {
    path: '/milk',
    name: 'milk',
    component: MilkView,
  },
  {
    path: '/backups',
    name: 'backups',
    component: BackupsView,
  },
  {
    path: '/upload',
    name: 'upload',
    component: UploadView
  },
  {
    path: '/syncs',
    name: 'syncs',
    component: SyncsView,
  },
  {
    path: '/statistics',
    name: 'statistics',
    component: StatisticsView,
  },
  {
    path: '/settings',
    name: 'settings',
    component: SettingsView,
  },
  {
    path: '*',
    redirect: '/'
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})
const authService = new AuthService();
const snackbarService = new SnackbarSercie()

router.beforeEach(async (to, from, next) => {
  const notProtectedRoutes = ['registrate', 'login', 'verifyRegistration', 'landingPage', 'resetPassword', 'privacy', 'licence', 'contact', 'termsAndConditions']
  // try access protected routes
  if (!store.state.user && (to.name === 'landingPage' || !notProtectedRoutes.includes(to.name)) && from.name !== 'login') {
    console.log('getting user in route')
    const resUser: any = await authService.getUserRequest().catch((error: any) => {
      // try to access protected routes but not authenticated
      if (error.response.status === 401) {
        store.state.redirectToFromGuard = to.fullPath;
        if (to.name === 'landingPage') {
          next();
        } else {
          next({ name: 'login' })
        }
      } else {
        next({ name: 'login' })
        snackbarService.notify({ text: `Error loading user: ${error}` })
      }
    })
    if (!resUser) {
      console.error('Error getting user')
    }
    const user = resUser.data;
    store.state.user = user;
    const resAccount: any = await authService.getAccount(user.account_id)
    store.state.account = resAccount.data;
    if (store.state.account.farms.length > 0) {
      store.state.selectedFarmId = store.state.account.farms[0].id;
    }
    await authService.refreshToken();
    // landing page only visible if not logged in
    if (to.name === 'landingPage') {
      next('home')
    } else {
      next();
    }
  } else  {
    console.log('next in let pass')
    next()
  }
})

export default router
